import { IconName } from './assets/IconNames';

export const iconNamesArray: Array<IconName> = Object.values(IconName);
